import flatpickr from "flatpickr";

flatpickr(".flatpickr", {
    dateFormat: 'd.m.Y',
    locale: {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
            longhand: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
        },
        months: {
            shorthand: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čvn', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
            longhand: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
        },
    },
});
